const API_BASE_URL = process.env.REACT_APP_API_URL;

// Fetch active popular destinations for public display
export async function getActivePopularDestinations() {
  try {
    const response = await fetch(`${API_BASE_URL}/api/popular-destinations/active`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Check if response is HTML (server error page)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('text/html')) {
      console.error('API Call - Received HTML response instead of JSON');
      throw new Error('Server connection error. Please ensure the backend server is running on port 5000.');
    }

    if (!response.ok) {
      let errorMessage = 'Failed to fetch popular destinations';
      try {
        const error = await response.json();
        console.error('API Call - Get popular destinations error response:', error);
        errorMessage = error.message || errorMessage;
      } catch (parseError) {
        console.error('API Call - Failed to parse error response:', parseError);
        errorMessage = `Server error (${response.status})`;
      }
      throw new Error(errorMessage);
    }

    let result;
    try {
      result = await response.json();
      // Data is already filtered and sorted by the backend
      return result;
    } catch (parseError) {
      console.error('API Call - Failed to parse popular destinations response:', parseError);
      throw new Error('Invalid server response format');
    }
  } catch (error) {
    console.error('API Call - Get popular destinations fetch error:', error);
    
    // Provide user-friendly error messages
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Unable to connect to server. Please check if the backend is running.');
    }
    
    throw error;
  }
}

// Get all popular destinations (for admin use)
export async function getAllPopularDestinations() {
  try {
    const response = await fetch(`${API_BASE_URL}/api/popular-destinations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch popular destinations');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get all popular destinations error:', error);
    throw error;
  }
}

// Get single popular destination by ID
export async function getPopularDestinationById(id) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/popular-destinations/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to fetch popular destination');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Get popular destination error:', error);
    throw error;
  }
}

// Create new popular destination
export async function createPopularDestination(destinationData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/popular-destinations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(destinationData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to create popular destination');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Create popular destination error:', error);
    throw error;
  }
}

// Update popular destination
export async function updatePopularDestination(id, destinationData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/popular-destinations/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(destinationData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to update popular destination');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Update popular destination error:', error);
    throw error;
  }
}

// Delete/Deactivate popular destination
export async function deletePopularDestination(id) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/popular-destinations/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to delete popular destination');
    }

    return await response.json();
  } catch (error) {
    console.error('API Call - Delete popular destination error:', error);
    throw error;
  }
}